import { t } from '@lingui/core/macro';
import { Trans } from '@lingui/react/macro';
import { Button, Dialog, DialogError, DialogFooter, DialogHeader, DialogLoading, Typography } from '@pocketlaw/tetris';
import { Falcon } from '@pocketlaw/tetris/macro';
import { useWorkflowCheckResponse } from 'app/domains/workflows/features/useWorkflowCheckResponse';
import { localizedFormatDate } from 'shared/domains/common-utils';
import { Content } from './Content';
export function RequirementCheckedDialog(props) {
    const { userName, timestamp, documentChatId, onClose } = props;
    const { requirementCheckedState } = useWorkflowCheckResponse(documentChatId);
    const formattedTimestamp = localizedFormatDate(timestamp, {
        day: 'numeric',
        month: 'short',
        year: 'numeric',
        hour: 'numeric',
        minute: 'numeric',
    });
    const subtitle = t({
        message: `Started by ${userName} on ${formattedTimestamp}`,
        comment: 'Approval requirement check dialog - Subtitle',
    });
    return (<Dialog>
      <DialogHeader icon={<Falcon icon="eye"/>} title={t({
            message: 'Approval requirement check',
            comment: 'Approval requirement check dialog - Title',
        })} subtitle={subtitle}/>
      {requirementCheckedState.type === 'loading' && <DialogLoading />}

      {requirementCheckedState.type === 'error' && (<DialogError title={t({ message: 'Error', comment: 'Approval requirement check dialog - Error title' })} description={t({
                message: 'Something went wrong while loading the dialog, please try again.',
                comment: 'Approval requirement check dialog - Error description',
            })} actions={<Typography $fontSize="tiny" $appearance="100">
              {requirementCheckedState.code}
            </Typography>}/>)}

      {requirementCheckedState.type === 'finished' && (<Content plaiResponse={requirementCheckedState.plaiResponse} additionalContext={requirementCheckedState.additionalContext} workflowUsed={requirementCheckedState.workflowUsed}/>)}
      <DialogFooter>
        <Button size="small" appearance="secondary" onClick={onClose}>
          <Trans comment="Approval requirement check dialog - Close button label">Close</Trans>
        </Button>
      </DialogFooter>
    </Dialog>);
}
